import React from "react";
import Achievements from "../Achievements";
import PersonalInfo from "../PersonalInfo";
import Experience from "../Experience";
import Education from "../Education";

const beyondCodeText1 = "Outside of software development, I’m a competitive combat sports athlete. I compete in MMA and train boxing and wrestling. This background shapes my mindset: discipline, ambition, resilience and continuous improvement."
const beyondCodeText2 = "I bring the same values into software, business and product development. I’m also interested in business, finance and financial markets, especially how ideas can turn into long-term opportunities.";
const ModalContent = () => {
  return (
    <>
      <div className="row">
        <div className="col-6">
          <h3>Professional Snapshot</h3>
          <PersonalInfo />
          <div className="edina_tm_button">
            <a href="Bacim.pdf" download className="color">
              Download CV
            </a>
          </div>
        </div>
        {/* End  Professional Snapshot */}

        <div className="col-6 achievements-wrapper">
          <h3>Highlights</h3>
          <Achievements />
        </div>
        {/* End  Highlights */}     
      </div>
      {/* End .row */}

      <div className="row resume-box">
        <div className="col-6">
          <h3>Experience</h3>
          <Experience />
        </div>
        {/* End  Experience */}

        <div className="col-6">
          <h3>Education</h3>
          <Education />
        </div>
        {/* End  Education */}
      </div>

      <div className="row beyond-code-row">
        <div className="col-12">
          <div className="beyond-code-box">
            <h3>Beyond Code</h3>
            <p>{beyondCodeText1}</p>
            <p>{beyondCodeText2}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalContent;
